import { Edit } from '@mui/icons-material';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from '@mui/material';
import { FC, useCallback } from 'react';
import { EmailField, Loading, TextField, useShowController } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

export const UserShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const {
    record: { firstName, lastName, username, id } = {},
    isLoading,
    isFetching,
  } = data;

  const handleClickEdit = useCallback(() => {
    navigate(`/users/${id}`);
  }, [id, navigate]);

  if (isLoading || isFetching) {
    return <Loading />;
  }
  return (
    <Card className={styles.UserShow}>
      <CardHeader
        avatar={<Avatar>{firstName.slice(0, 1)}</Avatar>}
        title={`${firstName} ${lastName}`}
        subheader={username}
        action={
          <IconButton aria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent className={styles.CardContent}>
        <EmailField source="email" record={data.record} />
        <TextField source="phone" record={data.record} />
      </CardContent>
    </Card>
  );
};
